export type SensitiveApprovalAuditAction = 'approve' | 'reject' | 'void'

export function getAuditActionText(action: SensitiveApprovalAuditAction): string {
  return {
    approve: '通过',
    reject: '拒绝',
    void: '作废',
  }[action]
}

export function shouldPromptAuditReason(_action: SensitiveApprovalAuditAction): boolean {
  return false
}

export function getAuditActionConfirmMessage(_action: SensitiveApprovalAuditAction): string | undefined {
  return undefined
}
